
import { useAudioPlayerStore } from "~/stores/audioplayer";
import { useRuntimeConfig } from '#imports';

export async function fetchTrack(trackId) {
  const audioPlayerStore = useAudioPlayerStore()
  let audioPlayerToken = audioPlayerStore.getAudioPlayerToken

  if (! audioPlayerToken) {
    await fetchAudioToken()
    audioPlayerToken = audioPlayerStore.getAudioPlayerToken
  }

  if (! trackId || ! audioPlayerToken) {
    return null;
  }

  const streamType = 'http_mp3_128_url'
  try {
    const response = await $fetch(`https://api.soundcloud.com/tracks/${trackId}/streams`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${audioPlayerToken}`,
      },
    });

    if (! response[streamType]) {
      throw new Error(`Error: ${response.statusText}`)
    }

    return response[streamType]
  } catch (e) {
    return null
  }
}

export async function fetchPlaylist(playlistId) {
  const audioPlayerStore = useAudioPlayerStore()
  let audioPlayerToken = audioPlayerStore.getAudioPlayerToken

  if (!audioPlayerToken) {
    await fetchAudioToken()
    audioPlayerToken = audioPlayerStore.getAudioPlayerToken
  }

  if (!playlistId || !audioPlayerToken) {
    return null;
  }

  const playlistUrl = `https://api.soundcloud.com/playlists/${playlistId}`;
  try {
    const playlistResponse = await $fetch(playlistUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${audioPlayerToken}`,
      },
    });
    
    if (playlistResponse?.tracks?.[0]?.id) {
      const firstTrackId = playlistResponse.tracks[0].id;
      return await fetchTrack(firstTrackId);
    }
  } catch (e) {
    console.error('Error fetching playlist:', e);
    return null;
  }
}

export async function fetchAudioToken() {
  const audioPlayerStore = useAudioPlayerStore();
  const config = useRuntimeConfig();
  const { audioPlayerToken } = await $fetch(`${config.public.baseUrl}/wp-json/content-search/v1/search?type=audio-token`, {
    method: 'GET',
  });

  if (audioPlayerToken) {
    audioPlayerStore.setAudioPlayerToken(audioPlayerToken)
  }

  return audioPlayerToken
}

export function formatTime(seconds) {
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = Math.floor(seconds % 60)

  // If hours are 0, omit it from the format, otherwise, pad it to 1+ digits
  const formattedHours = h > 0 ? `${h}:` : ''

  // Pad minutes and seconds with leading zeros if needed
  const formattedMinutes = h > 0
    ? m.toString().padStart(2, '0')
    : m
  const formattedSeconds = s.toString().padStart(2, '0');

  return `${formattedHours}${formattedMinutes}:${formattedSeconds}`
}